// extracted by mini-css-extract-plugin
module.exports = {"noScrolling":"AnchorArticles_noScrolling__9UgUp","wrapper":"AnchorArticles_wrapper__6F2_G","articles":"AnchorArticles_articles__js1LS"};